import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";

const PartRequestCardContainer = ({
    imageSrc,
    title,
    subtitle
}) => {
    return (
        <div style={styles.selectedItemContainer}>
            <img
                src={imageSrc}
                style={styles.carImage}
            />
            <div>
                <p style={styles.carNameText}>
                    {title}
                </p>

                <p style={styles.carDescriptionText}>
                    {subtitle}
                </p>
            </div>
        </div>
    );
};


export default PartRequestCardContainer;

const styles = {
    selectedItemContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        border: "1px solid #0000003b",
        borderRadius: 8,
        paddingInline: 12,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: "#F3F4F6",
    },
    carImage: {
        width: "48px",
        height: "48px",
        border: "1px solid #0000003b",
        borderRadius: 8,
        objectFit: "cover"
    },
    carNameText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "20px",
        fontWeight: 600,
        color: "#000000"
    },
    carDescriptionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "#000000de",
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    }
};